import { buildJoinUrl, renderInviteQr, shareRoom } from './share-room';

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/**
 * Phone landing page for a scanned room. Does not join or request location.
 * The QR on this page is the direct join link, so a second phone can scan it.
 */
export function renderShareHandoff(
  container: HTMLElement,
  roomCode: string,
  checkWord: string,
  onJoin: () => void,
  onLeave: () => void,
): void {
  const code = roomCode.trim().toUpperCase();
  const check = checkWord.trim();
  const joinUrl = buildJoinUrl(code, { checkWord: check });
  const qr = renderInviteQr(joinUrl);

  container.innerHTML = `
    <div class="flex flex-col items-center min-h-screen bg-tesla-bg px-6 py-8 gap-6">
      <div class="w-full max-w-md text-center">
        <h1 class="text-[22px] font-light text-white uppercase tracking-[0.32em]">Tesla With Me</h1>
        <p class="text-tesla-muted mt-2 text-[11px] uppercase tracking-[0.22em]">Room invite</p>
      </div>

      <div class="w-full max-w-md bg-tesla-surface border border-white/[0.08] rounded-2xl p-6 text-center">
        <div class="text-white text-2xl font-semibold tracking-[0.18em]">${escapeHtml(code)}</div>
        ${check ? `<p class="text-tesla-muted text-sm mt-2">Check word: ${escapeHtml(check)}</p>` : ''}
        <div class="mx-auto mt-5 bg-white rounded-xl p-3 w-fit [&_svg]:w-56 [&_svg]:h-56">${qr}</div>
        <p class="text-tesla-muted text-sm mt-4">
          Show this code to someone next to you, or send the invite from this phone.
        </p>
        <button id="share-join"
          class="w-full mt-5 bg-tesla-cyan text-white font-semibold rounded-full py-4 text-lg active:opacity-75">
          Join this room
        </button>
        <button id="share-send"
          class="w-full mt-3 border border-white/15 text-white rounded-full py-4 text-lg active:opacity-75">
          Share
        </button>
        <p id="share-status" class="text-tesla-muted text-sm mt-3 min-h-[20px]"></p>
        <button id="share-leave" class="mt-2 text-tesla-muted text-sm py-3 active:opacity-75">
          Not now
        </button>
      </div>
    </div>`;

  document.getElementById('share-join')!.addEventListener('click', onJoin);
  document.getElementById('share-leave')!.addEventListener('click', onLeave);
  document.getElementById('share-send')!.addEventListener('click', async () => {
    const status = document.getElementById('share-status');
    if (!status) return;
    const result = await shareRoom(code, { checkWord: check });
    if (result === 'shared') status.textContent = 'Invite opened in your share sheet.';
    else if (result === 'copied') status.textContent = 'Invite copied. Paste it into iMessage, SMS, or anywhere else.';
    else if (result === 'cancelled') status.textContent = '';
    else status.textContent = 'Sharing is not available in this browser.';
  });
}
